import React, { useEffect, useState } from "react";
import "./CryptoJourney.css";
import cryptoIcon from "../images/task.png";
import { Link } from "react-router-dom"

const journeySteps = [
  { title: "Create Your Account Now", step: 1 , location : '/register'},
  { title: "Fund Your Wallet", step: 2 , location : '/login'},
  { title: "Start Trading and Earning", step: 3 , location : '/login'},
];

const CryptoJourney = () => {
  const [hoveredCard, setHoveredCard] = useState(null);

  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      @keyframes float {
        0%, 100% { transform: translateY(0px) rotate(0deg); }
        50% { transform: translateY(-20px) rotate(5deg); }
      }
      @keyframes pulse {
        0%, 100% { opacity: 0.3; transform: scale(1); }
        50% { opacity: 0.6; transform: scale(1.1); }
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <div className="crypto-container pt-0">
      <div className="crypto-background-pattern"></div>
      <div className="crypto-content">
        <div className="crypto-left">
          <h5 className="display-6 fw-bolder">
            FUEL YOUR JOURNEY IN CRYPTO
          </h5>

          <div className="crypto-icon-container">
            <div className="crypto-glow"></div>
            <img
              src={cryptoIcon}
              alt="Crypto Journey"
              className="crypto-image"
            />
          </div>
        </div>

        <div className="crypto-right">
          {journeySteps.map((step, index) => (
            <Link to={step.location} style={{textDecoration:'none'}}
              key={index}
              className={`step-card ${hoveredCard === index ? "hovered" : ""}`}
              onMouseEnter={() => setHoveredCard(index)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className={`step-shimmer ${hoveredCard === index ? "shimmer-active" : ""}`}></div>

              <div className="step-content">
                <div className="step-number">{step.step}</div>
                <div className="step-title">{step.title}</div>
              </div>

              <div className={`step-arrow ${hoveredCard === index ? "arrow-hover" : ""}`}>›</div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CryptoJourney;
